"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Redirection {
    redirect(url) {
        window.location.href = url;
    }
    open(url) {
        window.open(url);
    }
}
exports.default = Redirection;
